/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type OrganizationGroupResponsePagedResult,
    OrganizationGroupResponsePagedResultFromJSON,
    OrganizationGroupResponsePagedResultToJSON,
} from '../models/OrganizationGroupResponsePagedResult';
import {
    type OrganizationGroupSearchOrderBy,
    OrganizationGroupSearchOrderByFromJSON,
    OrganizationGroupSearchOrderByToJSON,
} from '../models/OrganizationGroupSearchOrderBy';
import {
    type OrganizationGroupType,
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeToJSON,
} from '../models/OrganizationGroupType';
import {
    type OrganizationResponsePagedResult,
    OrganizationResponsePagedResultFromJSON,
    OrganizationResponsePagedResultToJSON,
} from '../models/OrganizationResponsePagedResult';
import {
    type OrganizationSearchOrderBy,
    OrganizationSearchOrderByFromJSON,
    OrganizationSearchOrderByToJSON,
} from '../models/OrganizationSearchOrderBy';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiOrganizationGroupsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: OrganizationGroupSearchOrderBy;
}

export interface ApiOrganizationGroupsOrganizationsGetRequest {
    organizationGroupIds?: Array<any>;
    organizationGroupType?: OrganizationGroupType;
    isActive?: boolean;
    filterByUserCreation?: boolean;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: OrganizationSearchOrderBy;
}

/**
 * 
 */
export class OrganizationGroupsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiOrganizationGroupsGet without sending the request
     */
    async apiOrganizationGroupsGetRequestOpts(requestParameters: ApiOrganizationGroupsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsGetRaw(requestParameters: ApiOrganizationGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationGroupResponsePagedResult>> {
        const requestOptions = await this.apiOrganizationGroupsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationGroupResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGroupsGet(requestParameters: ApiOrganizationGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationGroupResponsePagedResult> {
        const response = await this.apiOrganizationGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiOrganizationGroupsOrganizationsGet without sending the request
     */
    async apiOrganizationGroupsOrganizationsGetRequestOpts(requestParameters: ApiOrganizationGroupsOrganizationsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['organizationGroupIds'] != null) {
            queryParameters['OrganizationGroupIds'] = requestParameters['organizationGroupIds'];
        }

        if (requestParameters['organizationGroupType'] != null) {
            queryParameters['OrganizationGroupType'] = requestParameters['organizationGroupType'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['IsActive'] = requestParameters['isActive'];
        }

        if (requestParameters['filterByUserCreation'] != null) {
            queryParameters['FilterByUserCreation'] = requestParameters['filterByUserCreation'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/organization-groups/organizations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiOrganizationGroupsOrganizationsGetRaw(requestParameters: ApiOrganizationGroupsOrganizationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationResponsePagedResult>> {
        const requestOptions = await this.apiOrganizationGroupsOrganizationsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGroupsOrganizationsGet(requestParameters: ApiOrganizationGroupsOrganizationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationResponsePagedResult> {
        const response = await this.apiOrganizationGroupsOrganizationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
